var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DetailedSlotGeneric',{staticClass:"detailed-slot-reserved"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"detailed-slot-reserved__patient"},[_vm._v(" "+_vm._s(_vm.event.patient.fullName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }